import type * as React from 'react';

import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { UnstyledLink } from '@egr/xbox/egr-gui-elements/single-components/UnstyledLink';

interface FooterLinkProps {
    href: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    title: string;
    isLast?: boolean;
    id: string;
}

const FooterLink: React.FC<FooterLinkProps> = ({ href, onClick, title, isLast, id }) => {
    const theme = useTheme();
    return (
        <>
            <div
                style={{ marginLeft: 4, marginRight: 4 }}
                data-testid={`footer-${id}`}
            >
                <UnstyledLink
                    href={href}
                    onClick={onClick}
                    target={href.startsWith('http') ? '_blank' : undefined}
                    rel={href.startsWith('http') ? 'noreferrer' : undefined}
                >
                    <Typography variant="footer">{title}</Typography>
                </UnstyledLink>
            </div>
            {!isLast && <span style={{ color: theme.palette.text.disabled }}> | </span>}
        </>
    );
};

export default FooterLink;
